import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AppsPage from "@/pages/AppsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import SelahDailyPrivacyPage from "@/pages/SelahDailyPrivacyPage";
import ScribeMindPrivacyPage from "@/pages/ScribeMindPrivacyPage";
import JoshPage from "@/pages/JoshPage";
import ScribeMindPage from "@/pages/ScribeMindPage";
import SelahDailyPage from "@/pages/SelahDailyPage";
import SEOManager from "@/components/SEOManager";
import ScrollToTop from "@/components/ScrollToTop";
import ExternalRedirectPage from "@/components/ExternalRedirectPage";

function App() {
  const joshyPrivacyUrl = "https://www.getjoshy.com/privacy/joshy";
  const joshyTermsUrl = "https://www.getjoshy.com/terms/joshy";

  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <SEOManager />
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apps" element={<AppsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/joshy" element={<JoshPage />} />
            <Route path="/josh" element={<JoshPage />} />
            <Route path="/joshai" element={<JoshPage />} />
            <Route path="/scribemind" element={<ScribeMindPage />} />
            <Route path="/scribe-mind" element={<ScribeMindPage />} />
            <Route path="/selahdaily" element={<SelahDailyPage />} />
            <Route path="/selah-daily" element={<SelahDailyPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/privacy/josh" element={<ExternalRedirectPage url={joshyPrivacyUrl} label="Open Joshy Privacy Policy" />} />
            <Route path="/privacy/joshy" element={<ExternalRedirectPage url={joshyPrivacyUrl} label="Open Joshy Privacy Policy" />} />
            <Route path="/privacy/selah-daily" element={<SelahDailyPrivacyPage />} />
            <Route path="/privacy/scribemind" element={<ScribeMindPrivacyPage />} />
            <Route path="/terms/josh" element={<ExternalRedirectPage url={joshyTermsUrl} label="Open Joshy Terms & Conditions" />} />
            <Route path="/terms/joshy" element={<ExternalRedirectPage url={joshyTermsUrl} label="Open Joshy Terms & Conditions" />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
